import {
  ProgramCodeBook,
  ProgramType
} from "../../models/Program";
import { ProgramRequestDetail } from "../../models/ProgramRequest";
import { ExpertiseExistingProgramInfo } from "./ExpertiseExistingProgramInfo";
import { MiddleSchoolProgramInfo } from "./MiddleSchoolProgramInfo";

interface Props {
  programTypeId: number;
  programId: number;
  programData?: ProgramCodeBook;
}

export function ExistingProgramInfo({
  programTypeId,
  programId,
  programData
}: Props) {
  if (
    programTypeId === ProgramType.ForeignLanguageLearningPrograms && programData
  ) {
    return <></>;
  } else if (
    (
      programTypeId === ProgramType.MiddleSchoolShorterThanThreeYearsPrograms ||
      programTypeId === ProgramType.MiddleSchoolThreeYearsPrograms ||
      programTypeId === ProgramType.MiddleSchoolLongerThanThreeYearsPrograms
    ) && programData
  ) {
    return (
      <MiddleSchoolProgramInfo
        programData={programData}
      />
    );
  } else if (
    (
      programTypeId === ProgramType.TrainingPrograms ||
      programTypeId === ProgramType.CraftsAndArtsTrainingPrograms ||
      programTypeId === ProgramType.CraftsSpecializationPrograms ||
      programTypeId === ProgramType.RefinementPrograms ||      
      programTypeId === ProgramType.NewVocationalCurriculum
    ) && programData
  ) {
    return (
      <ExpertiseExistingProgramInfo
        programData={programData}
      />
    );
  } else {
    return <></>;
  }
}
